import { getFormsByName } from "@/api/forms.service";
export const useFormSearch = () => {
  const itemTitle = i => i.name;
  return {
    itemTitle,
    comparisonValue: v => v.id,
    fetchResults: async (search, searchArgs) => {
      const res = await getFormsByName({ name: search });

      const items = res.toSorted((a, b) =>
        itemTitle(a).localeCompare(itemTitle(b))
      );

      if (searchArgs.currentFormId) {
        const index = items.findIndex(v => v.id === searchArgs.currentFormId);
        if (index > 0) items.splice(index, 1);
      }

      return items;
    }
  };
};
